import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import Page from '../../components/Page';
import { Grid, Container, Header, Icon, Segment, Table, Label, Divider } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { post } from '../../util/api';

const barOptions = {
	scales: {
		xAxes: [{ stacked: false }],
		yAxes: [{ stacked: false, ticks: { min: 0 } }],
	},
	tooltips: {
		mode: 'index',
		intersect: false,
		filter: (a) => a.yLabel,
	},
	hover: {
		mode: 'nearest',
		intersect: true,
	},
	legend: {
		display: false,
	},
};
const ChartWrap = (props) => (
	<Grid.Column width={props.width}>
		<Header as="h4" attached="top">
			<Icon name={props.icon || 'chart bar'} />
			<Header.Content>{props.title}</Header.Content>
		</Header>
		<Segment attached>{props.children}</Segment>
	</Grid.Column>
);
const CardWrap = (props) => (
	<Grid.Column width={props.width}>
		<Segment textAlign="center" style={{ paddingTop: 50, height: 200 }} size="massive">
			<Label size="large" color={props.color} attached="top">
				{props.title}
			</Label>
			<div>{props.data}</div>
			<Divider />
			<div style={{ fontSize: '12px' }}>{props.description}</div>
		</Segment>
	</Grid.Column>
);
const TableBodyGen = (data, keys) => (
	<Table.Body>
		{_.map(data, (val, index) => (
			<Table.Row key={index}>
				{_.map(keys, (k, i) => (
					<Table.Cell key={index + '-' + i}>{val[k]}</Table.Cell>
				))}
			</Table.Row>
		))}
	</Table.Body>
);
class Analytic extends Component {
	state = {
		loading: true,
		filter: '',
		type: 'day',
		start_date: moment().subtract(7, 'day').startOf('day'),
		end_date: moment(),
		today: moment(),
		open: false,
		column: null,
		direction: null,
	};
	componentDidMount() {
		this.postApis();
	}
	async postApis() {
		let { filter, type } = this.state;
		let { end_date, start_date } = this.props;
		this.lastLoad = { end_date, start_date, type, filter };
		//let pid = '12b3119316d577ac14bd07067e6fa2be'; // _.get(this.props, 'user.products.0.id');
		let data = { start_date, end_date };
		const [closedInfo, takenInfo, chartInfo, statusInfo] = await Promise.all([
			post('/maytapi/analytics', {
				name: 'closedInfo',
				data,
			}),
			post('/maytapi/analytics', {
				name: 'takenInfoByAgents',
				data,
			}),
			post('/maytapi/analytics', {
				name: 'chartInfo',
				data,
			}),
			post('/maytapi/analytics', {
				name: 'statusInfo',
				data,
			}),
		]);
		let general = _.get(statusInfo, 'data.data.general');
		let agentStatus = _.get(statusInfo, 'data.data.agent');
		let parsed = parser(_.get(chartInfo, 'data.data.request_chart_result'), start_date, end_date);
		let agentClose = _.get(closedInfo, 'data.data.byAgents.byAgents');
		let agentTaken = _.get(takenInfo, 'data.data.byAgents');
		let waitingIssues = (agentStatus && _.find(agentStatus, { title: 'Bekleyen' }).count) || 0;
		//console.log('statusInfo', agentStatus);
		/* var agentStatusObj = {
			'Açık/Operatör': 'On/Operator',
			Bekleyen: 'Waiting',
			Kapılı: 'Close',
			'Etkileşime Geçilmemiş': 'No Interaction',
			Diğer: 'Other',
		}; */
		var closedInfoObj = {
			genel: 'general',
		};
		var agentStatusArr = ['On/Operator', 'Waiting', 'Close', 'No Interaction', 'Other'];
		//console.log(closedInfo);
		if (agentStatus) {
			_.map(agentStatus, (key, i) => {
				agentStatus[i].title = agentStatusArr[i];
			});
		}
		if (closedInfo && closedInfo.data.data.closedInfo) {
			_.map(closedInfo.data.data.closedInfo, (key, i) => {
				closedInfo.data.data.closedInfo[i]._id = closedInfoObj[closedInfo.data.data.closedInfo[i]._id];
			});
		}
		this.setState({
			loading: false,
			totalUser: general && _.find(general, { title: 'Agent' }).count,
			totalMessage: _.get(chartInfo, 'data.data.total_message'),
			agentClose: _.get(closedInfo, 'data.data.byAgents.byAgents'),
			agentCloseTotal: _.get(closedInfo, 'data.data.byAgents.byAgentTotal'),
			agentTaken: _.get(takenInfo, 'data.data.byAgents'),
			agentTakenTotal: _.get(takenInfo, 'data.data.byAgentTotal'),
			agentStatus,
			waitingIssues,
			closedDetail: _.get(closedInfo, 'data.data.closedInfo'),
			merged: this.mergeAgents(agentTaken, agentClose),
			...parsed,
			statusInfo,
		});
	}

	dateChange = ({ selection }) => {
		let start_date = moment(selection.startDate).startOf('day');
		let end_date = moment(selection.endDate);
		if (end_date.format('YYYY-MM-DD') !== this.state.today.format('YYYY-MM-DD')) {
			end_date = end_date.endOf('day');
		} else {
			end_date = moment();
		}
		this.setState({ start_date, end_date });
	};

	handleOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	refresh = () => {
		this.checkUpdate(this.state, ['end_date', 'start_date']);
	};

	checkUpdate(state, list) {
		if (!state) state = this.state;
		let compare = this.lastLoad;
		//this.setState({ postEndDate: moment(this.state.end_date).add('1', 'day') });
		let checkList = list || ['type', 'filter'];

		for (let i = 0; i < checkList.length; i++) {
			const key = checkList[i];
			if (state[key] !== compare[key]) {
				if (key === 'filter') return this.loadOffline();
				return this.postApis();
			}
		}
	}

	mergeAgents(taken, close) {
		let agents = {};
		_.each(taken, ({ email, count }) => {
			if (!agents[email]) agents[email] = { taken: 0, close: 0 };
			agents[email].taken = count;
		});
		_.each(close, ({ email, count }) => {
			if (!agents[email]) agents[email] = { taken: 0, close: 0 };
			agents[email].close = count;
		});
		return _.map(agents, ({ taken, close }, email) => {
			return {
				email,
				taken,
				close,
			};
		});
	}

	btnClick = (e, { name }) => {
		this.setState({ type: name });
	};

	componentDidUpdate(oldProps, oldState) {
		const check_list = ['start_date', 'end_date'];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			if (key === 'start_date' || key === 'end_date') {
				if (this.props[key] !== oldProps[key]) {
					this.postApis();
					break;
				}
			}
			if (this.state[key] !== oldState[key]) {
				this.postApis();
				break;
			}
		}
	}
	render() {
		if (this.state.loading) return <Page.Loader />;
		return (
			<Container>
				<Grid stackable columns={2} style={{ width: '100%', margin: 0 }}>
					<CardWrap
						width={4}
						title="Total User"
						color="orange"
						data={this.state.totalUser || 0}
						description="How many unique user use your widget."
					/>
					<CardWrap
						width={4}
						title="Total Message"
						color="green"
						data={this.state.totalMessage || 0}
						description="How many unique user use your widget."
					/>
					<CardWrap
						width={4}
						title="Closed Issues By Agents"
						color="blue"
						data={this.state.agentCloseTotal || 0}
						description="How many unique user use your widget."
					/>
					<CardWrap
						width={4}
						title="Waiting Issues"
						color="yellow"
						data={this.state.waitingIssues || 0}
						description="How many unique user use your widget."
					/>
					<ChartWrap width={8} title="User">
						<Line data={this.state.userChartData} options={barOptions} />
					</ChartWrap>
					<ChartWrap width={8} title="Message">
						<Line data={this.state.messageChartData} options={barOptions} />
					</ChartWrap>

					<Grid.Column width={8}>
						<Segment>
							<h3 style={{ textAlign: 'center' }}>Status of Conversations</h3>
							<Table celled unstackable fixed striped>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell>Status</Table.HeaderCell>
										<Table.HeaderCell>Count</Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								{this.state.agentStatus ? (
									TableBodyGen(this.state.agentStatus, ['title', 'count'])
								) : (
									<Table.Row>
										<Table.Cell style={{ textAlign: 'center' }} colSpan="2">
											There is no data for showing.
										</Table.Cell>
									</Table.Row>
								)}
								<Table.Footer />
							</Table>
						</Segment>
					</Grid.Column>
					<Grid.Column width={8}>
						<Segment>
							<h3 style={{ textAlign: 'center' }}>Issue Details</h3>
							<Table celled unstackable fixed striped>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell>Title</Table.HeaderCell>
										<Table.HeaderCell>Count</Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								{this.state.closedDetail && this.state.closedDetail.length ? (
									TableBodyGen(this.state.closedDetail, ['_id', 'count'])
								) : (
									<Table.Row>
										<Table.Cell style={{ textAlign: 'center' }} colSpan="2">
											There is no data for showing.
										</Table.Cell>
									</Table.Row>
								)}
								<Table.Footer />
							</Table>
						</Segment>
					</Grid.Column>

					<Grid.Column width={8}>
						<Segment>
							<h3 style={{ textAlign: 'center' }}>Closed By Agents</h3>
							<Table celled unstackable fixed striped>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell>Agent Email</Table.HeaderCell>
										<Table.HeaderCell>Taken</Table.HeaderCell>
										<Table.HeaderCell>Close</Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								{this.state.merged.length ? (
									TableBodyGen(this.state.merged, ['email', 'taken', 'close'])
								) : (
									<Table.Row>
										<Table.Cell style={{ textAlign: 'center' }} colSpan="3">
											There is no data for showing.
										</Table.Cell>
									</Table.Row>
								)}

								<Table.Footer />
							</Table>
						</Segment>
					</Grid.Column>
				</Grid>
			</Container>
		);
	}
}

function parser(results, start, end) {
	let messageData = [];
	let userData = [];
	let labels = [];
	for (var m = moment(start); m.isBefore(end); m.add(1, 'days')) {
		let label = m.format('DD-MM');
		labels.push(label);
		let date = m.format('YYYY-MM-DD');
		let result = _.find(results, { _id: date });
		let { conv_count = 0, user_message_count = 0 } = result || {};
		messageData.push(user_message_count);
		userData.push(conv_count);
	}
	/* let userData = _.map(results, 'conv_count');
	let messageData = _.map(results, 'count'); */

	let userGraphData = [
		{
			label: 'User',
			backgroundColor: '#F2711C',
			data: userData,
			fill: false,
		},
	];
	let messageGraphData = [
		{
			label: 'Message',
			backgroundColor: '#21BA45',
			data: messageData,
			fill: false,
		},
	];

	let userChartData = { labels, datasets: userGraphData };
	let messageChartData = { labels, datasets: messageGraphData };
	return { userChartData, messageChartData };
}

export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(Analytic);
